export const messages = {
  volume: {
    title: 'Объём партии',
    label: 'т',
  },
  workWithoutVat: 'Работаю без НДС',
  workWithVat: 'Работаю с НДС',
  culturesSaleError: 'Что-то пошло не так. Обновите страницу',
  culturesSaleShowAllOffersButton: 'Посмотреть все предложения',
}
